import { useMutation, useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import {
  RolePermission,
  RolePermissionReqBody,
} from '../../../types/rolePermissions';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useRolePermissionsActions = (
  whichAction: 'rolePermissionList' | '',
  roleId?: number
) => {
  // query function to fetch all role permissions declared here
  const getRolePermissionListHandler = useQuery({
    queryKey: ['role-permission-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<RolePermission>>> => {
      const response = await getPrivateAxiosInstance('user').get(
        '/role/permissions/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'rolePermissionList'),
  });

  // query function to get role permissions by role id declared here
  const getRolePermissionsByRoleIdHandler = useQuery({
    queryKey: ['role-permission-by-role-id', roleId],
    queryFn: async (): Promise<AcademiaResponse<RolePermission>> => {
      const response = await getPrivateAxiosInstance('user').get(
        `/role/permissions/${roleId}/`
      );

      return response.data;
    },

    ...returnQueryConfig(!!roleId),
  });

  // mutation function to create new role permission declared here
  const createRolePermissionHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: RolePermissionReqBody;
    }): Promise<AcademiaResponse<RolePermission>> => {
      const response = await getPrivateAxiosInstance('user').post(
        '/role/permissions/create/',
        body
      );

      return response.data;
    },
  });

  const updateRolePermissionHandler = useMutation({
    mutationFn: async ({
      roleId,
      body,
    }: {
      roleId: number;
      body: RolePermissionReqBody;
    }): Promise<AcademiaResponse<RolePermission>> => {
      const response = await getPrivateAxiosInstance('user').patch(
        `/role/permissions/${roleId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  return {
    getRolePermissionListHandler,
    getRolePermissionsByRoleIdHandler,
    createRolePermissionHandler,
    updateRolePermissionHandler,
  };
};

export default useRolePermissionsActions;
